import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate, byteSize, openFile } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './advertisment.reducer';

export const AdvertismentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const advertismentEntity = useAppSelector(state => state.advertisment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="advertismentDetailsHeading">
          <Translate contentKey="activitiesApp.advertisment.detail.title">Advertisment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{advertismentEntity.id}</dd>
          <dt>
            <span id="fromDate">
              <Translate contentKey="activitiesApp.advertisment.fromDate">From Date</Translate>
            </span>
          </dt>
          <dd>
            {advertismentEntity.fromDate ? <TextFormat value={advertismentEntity.fromDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="toDate">
              <Translate contentKey="activitiesApp.advertisment.toDate">To Date</Translate>
            </span>
          </dt>
          <dd>
            {advertismentEntity.toDate ? <TextFormat value={advertismentEntity.toDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="active">
              <Translate contentKey="activitiesApp.advertisment.active">Active</Translate>
            </span>
          </dt>
          <dd>{advertismentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="imageurl">
              <Translate contentKey="activitiesApp.advertisment.imageurl">Imageurl</Translate>
            </span>
          </dt>
          <dd>{advertismentEntity.imageurl}</dd>
          <dt>
            <span id="activityType">
              <Translate contentKey="activitiesApp.advertisment.activityType">Activity Type</Translate>
            </span>
          </dt>
          <dd>{advertismentEntity.activityType}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="activitiesApp.advertisment.description">Description</Translate>
            </span>
          </dt>
          <dd>{advertismentEntity.description}</dd>
          <dt>
            <span id="advertismentImage">
              <Translate contentKey="activitiesApp.advertisment.advertismentImage">Advertisment Image</Translate>
            </span>
          </dt>
          <dd>
            {advertismentEntity.advertismentImage ? (
              <div>
                {advertismentEntity.advertismentImageContentType ? (
                  <a onClick={openFile(advertismentEntity.advertismentImageContentType, advertismentEntity.advertismentImage)}>
                    <img
                      src={`data:${advertismentEntity.advertismentImageContentType};base64,${advertismentEntity.advertismentImage}`}
                      style={{ maxHeight: '30px' }}
                    />
                  </a>
                ) : null}
                <span>
                  {advertismentEntity.advertismentImageContentType}, {byteSize(advertismentEntity.advertismentImage)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="activitiesApp.advertisment.city">City</Translate>
          </dt>
          <dd>{advertismentEntity.city ? advertismentEntity.city.cityName : ''}</dd>
        </dl>
        <Button tag={Link} to="/advertisment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/advertisment/${advertismentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AdvertismentDetail;
